import {Home} from "../pages/Home/Home";
import PromoCard from "../pages/PromoCard/PromoCard";
import List from "../pages/List/List";
import PromoFormCrystals from "../components/PromoForm/layers/PromoFormCrystals";
import PromoFormCryptoAndCrystals from "../components/PromoForm/layers/PromoFormCryptoAndCrystals";
import PromoFormOnlyCrypto from "../components/PromoForm/layers/PromoFormOnlyCrypto";
import PromoDetails from "../pages/PromoDetails/PromoDetails";
import Balance from "../pages/Balance/Balance";
import Payment from "../pages/Payment/Payment";
import { Game } from "../pages/Game/Game";
import CompletedPromo from "../pages/CompletedPromo/CompletedPromo";
import WalletPage from "../pages/WalletPage/WalletPage";
import Overview from "../pages/Overview/Overview";

export const pages = [
    {id: 0, component: <Home/>},
    {id: 1, component: <PromoFormCrystals/>},
    {id: 2, component: <PromoFormCryptoAndCrystals/>},
    {id: 3, component: <PromoFormOnlyCrypto/>},
    {id: 4, component: <Game/>},
    {id: 5, component: <PromoDetails/>},
    {id: 6, component: <Balance/>},
    {id: 7, component: <Payment/>},
    {id: 8, component: <CompletedPromo/>},
    {id: 9, component: <WalletPage/>},
    {id: 10, component: <Overview/>},
];
